import './Precompiled'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { checkCountry } from './CheckCountry'
import styled from 'styled-components'
import StoreCountry from '@Stores/StoreCountry'
import { store } from '@Stores/MainStore'
import App from './App'
import { observer } from 'mobx-react-lite'
import { StorageExtend } from '@Utils/StorageManager'
import { isSomething } from '@Utils/Utils'
import { lowerCase } from '@Utils/String'
import md5 from 'crypto-js/md5'
import { getParameterByName, getQueryString } from '@Configs/ConfigsHeader'
import { storeAPI } from '@Stores/StoreAPI'
import LoadingBar from '@Components/LoadingBar/LoadingBar'
import Spinner from '@Spinner'

const WebSkeleton = styled.div`
    width: ${window.innerWidth}px;
    height: ${window.innerHeight}px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Root = observer(props => {
    const [webReady, setWebReady] = useState(false)
    const [showCountryPortal, setShowCountryPortal] = useState(false)
    let thisInterval = null

    function deleteAllCookies() {
        let cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i]
            let eqPos = cookie.indexOf('=')
            let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
        }
    }

    function checkForceClear() {
        try {
            // -- Versioning for Developers --
            const VERSION_DEV = md5('2.4.x').toString()
            const clearStorageThenSetVersion = () => {
                console.log('%cForced clean storage.', 'font-weight: bold; color: red;')
                localStorage.clear()
                sessionStorage.clear()
                deleteAllCookies()

                StorageExtend.set(VERSION_DEV, 'development.version')
            }
            const preVersionDev = StorageExtend.get('development.version')
            if (isSomething(preVersionDev) || /reset/.test(window.location.href)) {
                if (preVersionDev !== VERSION_DEV) {
                    clearStorageThenSetVersion()
                    window.location.reload()
                }

                if(/reset/.test(window.location.href)) {
                    clearStorageThenSetVersion()
                    window.location.href = '/'
                }
            } else {
                StorageExtend.set(VERSION_DEV, 'development.version')
            }
            const versionStr = ''.concat('——————————————————————————————————————————————————')
            console.log('%c' + versionStr, 'font-weight: bold; color: blue;')
            if (process.env.NODE_ENV === 'development') {
                console.log('%cEnvironment: ' + process.env.NODE_ENV, 'font-weight: bold; color: red;')
            } else {
                console.log('%cEnvironment: ' + process.env.NODE_ENV, 'font-weight: bold; color: green;')
            }
            // ----------------------------------
        } catch (error) {
            if (error === 'string') {
                throw '- Found new development version, reload is required.'
            }
        }
    }

    useEffect(() => {
        checkForceClear()
        //* This is for webview to set isWebview flag*//
        window.document.addEventListener('message', function (e) {
            if (window.ReactNativeWebView !== undefined) {
                localStorage.setItem('isWebview', true)
                store.isWebview = true
                store.latestWebview = true
            }
        })
        //* This is for webview to set isWebview flag*//
        //* this is working on iOS *//
        window.addEventListener('message', function (e) {
            if (window.ReactNativeWebView !== undefined) {
                localStorage.setItem('isWebview', true)
                store.isWebview = true
                store.latestWebview = true
            }
        })

        if (getParameterByName('language')) {
            sessionStorage.setItem('redirect-language', getParameterByName('language'))
        }

        if (!/line-liff/.test(window.location.href) && !/line-login/.test(window.location.href)) {
            storeAPI.MainApiStartLoad.country = true
            const responseCountry = checkCountry()
            responseCountry.then(response => {
                if (response) {
                    if (response.success === true) {
                        if (response.needReload === true) {
                            if (response.path === '') {
                                setShowCountryPortal(true)
                                setWebReady(true)
                                storeAPI.setApiLoaded('country', true)
                                storeAPI.MainApiStartLoad.country = false
                                storeAPI.ShowCountryPortal = true
                            } else {
                                window.location.href = `${window.location.origin}/${response.path.replace('/', '')}`
                            }
                        } else {
                            StoreCountry.country = response.country

                            if (response.country.country !== StorageExtend.get('development.memoized-country')) {
                                sessionStorage.clear()
                            }

                            document.title = `UNICITY (${response.country.shorter})`
                            StorageExtend.set(lowerCase(response.country.country), 'development.memoized-country')

                            StoreCountry.init(response.data)
                            storeAPI.setApiLoaded('country', true)
                            storeAPI.MainApiStartLoad.country = false
                            storeAPI.ShowCountryPortal = false
                            // setWebReady(true)
                        }
                    } else {
                        window.location.href = `${window.location.origin}`
                    }
                }
            })
        } else {
            if (/line-login/.test(window.location.href)) {
                let currentCountry = localStorage.getItem('country')
                window.location.href = `/${currentCountry}/settings${window.location.search}`
            }
        }
    }, [])

    return (
        <>
            {/reset/.test(window.location.href) ? (
                <ResetLayout />
            ) : (
                <>
                    <LoadingBar />
                    {storeAPI.IsMainApiLoaded.country === true && (
                        <div style={storeAPI.IsCoreReady === false && showCountryPortal === false ? { visibility: 'hidden' } : {}}>
                            <App {...props} showCountryPortal={showCountryPortal} />
                        </div>
                    )}
                </>
            )}
        </>
    )
})

const ResetLayout = () => {

    return (
        <div style={{ minHeight: 300 }}>
            <Spinner />
        </div>
    )
}

ReactDOM.render(<Root />, document.getElementById('root'))
